import HttpClient from "./HttpClient";
import Attachment from "./Attachment";
export default class Problem {
    constructor(problem) {
        this.comment = problem.comment;
        this.company_id = problem.company_id;
        this.created_at = problem.created_at;
        this.description = problem.description;
        this.id = problem.id;
        this.order_code = problem.order_code;
        this.solved_at = problem.solved_at;
        this.status = problem.status;
        this.updated_at = problem.updated_at;
        this.user_id = problem.user_id;
        this.user_name = problem.user_name;
        this.time_spent = problem.time_spent;
        this.subject = problem.subject;
        this.attachments = this.getAttachements(problem.attachments);
    }

    getAttachements(problemAttachements) {
        const attachments = [];
        if (problemAttachements) {
            for (const attachment of problemAttachements) {
                attachments.push(new Attachment(attachment));
            }
        }
        return attachments;
    }

    static async loadProblems(filters) {
        const client = new HttpClient();
        const response = await client.instance.get("problems", filters);
        const problems = [];
        response.data.data.forEach(problem => {
            problems.push(new Problem(problem));
        });
        const page = response.data.current_page;
        const perPage = response.data.per_page;
        const pages = response.data.last_page;
        return { problems, page, perPage, pages }
    }

    static async createProblem(problem) {
        const client = new HttpClient();
        const response = await client.instance.post("problems", problem);
        const createdProblem = new Problem(response.data);
        return createdProblem;
    }

    async save() {
        const client = new HttpClient();
        const response = await client.instance.put(`problems/${this.id}`, this);
        return response.data
    }

    async remove() {
        const client = new HttpClient();
        const response = await client.instance.delete(`problems/${this.id}`);
        return response.data
    }
}